import React from "react"

import classNames from "classnames"

import { useStableSortedOrder } from "shared/lib/useStableSortedOrder"
import {
  TeamMember,
  UpdateTeamMemberInput
} from "shared/types/__generated__/graphql"

import "./styles/_team-member-list.scss"
import { TeamMemberListItem } from "./ui/TeamMemberListItem"

export interface TeamMemberListProps {
  teamMembers: TeamMember[] | null | undefined

  onUpdate?: (args: {
    teamMemberID: string
    updates: UpdateTeamMemberInput
  }) => void
  onResendInvitation?: (teamMemberID: string) => void
  onDelete?: (teamMemberID: string) => void

  isReadonly?: boolean
}

export const TeamMemberList = React.memo(
  ({ teamMembers, isReadonly, ...rest }: TeamMemberListProps) => {
    const orderedTeamMembers = useStableSortedOrder({ items: teamMembers })

    return (
      <ul
        className={classNames("team-member-list", {
          "team-member-list--readonly": isReadonly
        })}
        data-testid="team-member-list"
      >
        {orderedTeamMembers.map(teamMember => (
          <TeamMemberListItem
            {...rest}
            key={teamMember.id}
            teamMember={teamMember}
            isReadonly={isReadonly}
          />
        ))}
      </ul>
    )
  }
)
